/**
 * Medna Data Systems – Brand configuration
 * Source: Medna Brand Guidelines.pdf & Medna Brochure.pdf (project root)
 *
 * Colours and usage from Brand Guidelines:
 * - Deep navy and off-white = primary backgrounds
 * - Purple = accent (dividers, active states, emphasis)
 * - Do not alter logo gradient; use provided logo files only.
 */
export const MednaBrand = {
  name: 'Medna Data Systems',
  shortName: 'Medna',
  tagline: 'Digital Healthcare Excellence',

  // Official palette from Medna Brand Guidelines.pdf (Colours section)
  colors: {
    primaryDark: '#03101E',   // Deep navy – headers, footer, primary backgrounds (RGB 3,16,30)
    primary: '#6550C9',      // Purple – accent, buttons, links, key moments (RGB 101,80,201)
    accent: '#6550C9',       // Same as primary per guidelines (purple used sparingly as accent)
    secondary: '#A2C8DD',    // Light blue – optional secondary (RGB 162,200,221)
    light: '#F4F3F2',        // Off-white – light backgrounds (RGB 244,243,242)
    gray: '#D7D7D7',        // Gray – borders, secondary elements (RGB 215,215,215)
    text: '#0C0C0C',        // Near black – body text (RGB 12,12,12)
  },

  // Typography: Inter (Google Fonts) per Brand Guidelines
  fontFamily: 'Inter, sans-serif',

  website: 'https://mednadatasystems.com',
  websiteDisplay: 'www.mednadatasystems.com',
  supportEmail: 'sales@mednadatasystems.com',
  copyrightText: 'Medna Data Systems 2024',

  // From Medna Brochure.pdf – contact block
  phone: '+971 507098504',
  email: 'sales@mednadatasystems.com',
  address: 'IFZA Business Park, Dubai Silicon Oasis',
  city: 'Dubai',
  country: 'UAE',

  // Logo: files in public/brand-assets/ (medna-logo.png, medna-logo-dark.png)
  // Use full-colour gradient on light/dark per guidelines; do not alter or recreate.
  logo: `${process.env.PUBLIC_URL || ''}/brand-assets/medna-logo.png`,
  logoDark: `${process.env.PUBLIC_URL || ''}/brand-assets/medna-logo-dark.png`,
  // Display size (width in px; height auto to keep aspect ratio)
  logoWidth: 160,
  logoHeight: 72,
};

export default MednaBrand;
